import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO';
import shastraCatalog from '../data/shastra_catalog.json';

const ShastraLibraryPage = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const topics = shastraCatalog.topics || {};

  // Extract all subtopics for easy listing
  const allSubtopics = [];
  Object.keys(topics).forEach((mainKey) => {
    const mainObj = topics[mainKey];
    const subObj = mainObj.sub_topics || {};
    Object.keys(subObj).forEach((subKey) => {
      const item = subObj[subKey];
      allSubtopics.push({
        slug: subKey,
        mainKey: mainKey,
        mainTitle: mainObj.main_topic_tamil,
        subTitle: item.sub_topic_tamil,
        keywords: item.keywords || [],
        books: item.books_opinion || {}
      });
    });
  });

  const filteredSubtopics = allSubtopics.filter((item) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      item.subTitle.toLowerCase().includes(term) ||
      item.mainTitle.toLowerCase().includes(term) ||
      item.keywords.some((k) => k.toLowerCase().includes(term))
    );
  });

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '30px 20px', fontFamily: 'Arial, sans-serif' }}>
      <SEO
        title="டிஜிட்டல் தர்ம சாஸ்திர லைப்ரரி - தர்ம சிந்து, நிர்ணய சிந்து & ஸ்ம்ருதி முக்தாபலம் | Ahobilam.com"
        description="வேத தர்ம சாஸ்திர நூல்களின் (தர்ம சிந்து, நிர்ணய சிந்து, ஸ்ம்ருதி முக்தாபலம்) ஒப்பீட்டு விதிகள், விரத நிர்ணயம், ஶ்ராத்த விதிகள் மற்றும் ஆஹ்நிக கர்மங்கள் அடங்கிய டிஜிட்டல் சாஸ்திரக் களஞ்சியம்."
        keywords="தர்ம சாஸ்திரம், தர்ம சிந்து, நிர்ணய சிந்து, ஸ்ம்ருதி முக்தாபலம், ஹரிவாஸரம், ஏகாதசி விரதம், அஷ்டகா ஶ்ராத்தம், உபாகர்மா"
      />

      <header style={{ textAlign: 'center', marginBottom: '40px', background: 'linear-gradient(135deg, #1e3a8a 0%, #166534 100%)', padding: '40px 20px', borderRadius: '16px', color: '#ffffff', boxShadow: '0 10px 25px rgba(0,0,0,0.15)' }}>
        <h1 style={{ fontSize: '2.5rem', marginBottom: '15px', color: '#fef08a' }}>🕉️ டிஜிட்டல் தர்ம சாஸ்திர லைப்ரரி</h1>
        <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto 25px', color: '#e2e8f0', lineHeight: '1.6' }}>
          தர்ம சிந்து, நிர்ணய சிந்து, ஸ்ம்ருதி முக்தாபலம் (ஆஹ்நிக, கால, ஶ்ராத்த, ஆஸௌச, வர்ணாஶ்ரம காண்டங்கள்) ஆகிய அரிய சாஸ்திர நூல்களின் ஒப்பீட்டு நிர்ணயக் களஞ்சியம்.
        </p>

        {/* Search Bar */}
        <div style={{ maxWidth: '600px', margin: '0 auto', display: 'flex', gap: '10px' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="தேடல்: ஹரிவாஸரம், அஷ்டகா, உபாகர்மா, ஶ்ராத்தம்..."
            style={{ flex: 1, padding: '14px 20px', borderRadius: '30px', border: 'none', fontSize: '1.05rem', outline: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', color: '#1e3a8a' }}
          />
        </div>
      </header>

      {/* Catalog Grid */}
      <section>
        <h2 style={{ fontSize: '1.8rem', color: '#1e3a8a', marginBottom: '25px', borderBottom: '3px solid #166534', paddingBottom: '10px', display: 'inline-block' }}>
          சாஸ்திரத் தலைப்புகள் (Shastra Topics Catalog - {filteredSubtopics.length})
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '25px' }}>
          {filteredSubtopics.map((item) => (
            <div
              key={item.slug}
              style={{ background: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '25px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', transition: 'all 0.3s ease', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
            >
              <div>
                <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#166534', background: '#dcfce7', padding: '4px 10px', borderRadius: '20px', textTransform: 'uppercase' }}>
                  {item.mainTitle}
                </span>
                <h3 style={{ fontSize: '1.35rem', color: '#1e3a8a', margin: '15px 0 10px', lineHeight: '1.4' }}>
                  {item.subTitle}
                </h3>
                <p style={{ color: '#475569', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '20px' }}>
                  தர்ம சிந்து, நிர்ணய சிந்து மற்றும் ஸ்ம்ருதி முக்தாபலம் நூல்களின் சாஸ்திர பூர்வ ஒப்பீட்டு விதிகள்.
                </p>
              </div>

              <Link
                to={`/shastra-library/${item.slug}`}
                style={{ display: 'inline-block', textAlign: 'center', background: '#1e3a8a', color: '#ffffff', padding: '12px 20px', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold', fontSize: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
              >
                சாஸ்திர விதிகளை வாசிக்க ➔
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ShastraLibraryPage;
